module.exports = __webpack_public_path__ + "static/media/laptop-medical.e3100aea.svg";